import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

Vue.config.productionTip = false

import Clients from './components/Clients.vue'
import Client from './components/Client.vue'
import Connection from './components/Connection.vue'
import Server from './components/Server.vue'
import Servers from './components/Servers.vue'

Vue.use(VueRouter)

const router = new VueRouter({
	routes: [
		{path: '/', redirect: '/servers'},
		{path: '/servers', component: Servers},
		{path: '/servers/:id', component: Server, props: true},
		{path: '/servers/:server_id/:client_id', component: Connection, props: true},
		{path: '/clients', component: Clients},
		{path: '/clients/:id', component: Client, props: true},
		{path: '/clients/:client_id/:server_id', component: Connection, props: true},
	]
});

new Vue({
	router: router,
	render: h => h(App)
}).$mount('#app')
